import React from 'react';
import { t } from '../i18n';

export default function FinalCTA({ lang }) {
  const c = t(lang);

  return (
    <section className="py-20 md:py-24 bg-[#EEF4F2]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-[#0C3C3C] tracking-tight mb-4">
          {c.cta.title}
        </h2>
        <p className="text-lg text-teal-900/65 mb-8 leading-relaxed">{c.cta.sub}</p>
        <a
          href="/s"
          className="inline-flex items-center justify-center px-8 py-4 bg-[#0C3C3C] hover:bg-teal-800 text-white font-bold text-lg rounded-md transition-all duration-300 hover:-translate-y-0.5"
        >
          {c.cta.button}
        </a>
      </div>
    </section>
  );
}
